import { render, staticRenderFns } from "./fourth.vue?vue&type=template&id=54f97c74&"
import script from "./fourth.vue?vue&type=script&lang=js&"
export * from "./fourth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54f97c74')) {
      api.createRecord('54f97c74', component.options)
    } else {
      api.reload('54f97c74', component.options)
    }
    module.hot.accept("./fourth.vue?vue&type=template&id=54f97c74&", function () {
      api.rerender('54f97c74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/alf/homeComponents/first/fourth.vue"
export default component.exports